// Formatavimo funkcijos su tūkstančių atskyrimu (1 000, 10 000, ...)
export function formatNumber(value, decimals = 2) {
    if (value === null || isNaN(value))
        return '-';
    const str = value.toFixed(decimals);
    const [intPart, decPart] = str.split('.');
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return decimals > 0 ? `${formattedInt},${decPart}` : formattedInt;
}
export function formatInputForDisplay(val) {
    if (!(val === null || val === void 0 ? void 0 : val.trim()))
        return '';
    const cleaned = val.replace(/\s/g, '').replace(',', '.');
    const num = parseFloat(cleaned);
    if (isNaN(num))
        return val;
    const str = num.toString();
    const [intPart, decPart] = str.split('.');
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return decPart ? `${formattedInt},${decPart}` : formattedInt;
}
export function parseInputForStorage(val) {
    if (!(val === null || val === void 0 ? void 0 : val.trim()))
        return '';
    return val.replace(/\s/g, '').replace(',', '.');
}
